import { render, staticRenderFns } from "./Cnae.vue?vue&type=template&id=8c6614da"
import script from "./Cnae.vue?vue&type=script&lang=ts"
export * from "./Cnae.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports